import modal from './modal';

export default { 
	initialize: function () {
		//bind video play,pause buttons with respective video playbacks
		$('.play-pause-btn').click(function() {
			var $this = $(this),
				$linkedVideo = document.getElementById($(this).data('videoid'));
			if($linkedVideo !== undefined && $linkedVideo !== null) {
				if($this.hasClass('active')){
					$linkedVideo.pause();
				}
				else{
					$linkedVideo.play();
				}
				$this.toggleClass('active');
			}
	
			//Add class to hide picture tag once video played
			$this.parent().addClass('hide-poster');
			
			//link end event for playing video
			if($linkedVideo !== undefined && $linkedVideo !== null) {
				$linkedVideo.onended = function(){
					$this.removeClass('active');
				};
			}
		});

		$('.modal-close').click(function() {
			var $linkedVideo = document.getElementById($(this).data('videoid'));
			if($linkedVideo !== undefined && $linkedVideo !== null) {
				$linkedVideo.pause();
			}
		});
		
		$('#category-hero .slick-arrow').click(function() {
			var playPauseButton = $(this).parent('.slick-slider').find('.slick-active .play-pause-btn');
			var $linkedVideo = document.getElementById(playPauseButton.data('videoid'));
			if($linkedVideo !== undefined && $linkedVideo !== null) {
				$linkedVideo.pause();
				playPauseButton.removeClass('active');
			}
		});
	},

	init: function (cb) {
		if((typeof window.YT !== "undefined") && (typeof cb !== 'undefined')) {
			return cb();
		}

		window.onYouTubeIframeAPIReady = cb;

		// load youtube iframe api
		var tag = document.createElement("script");

		tag.async = true;
		tag.src = "https://www.youtube.com/iframe_api";

		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	},

	playInline: function ($ele, videoId) {
		var eleId = $ele.attr("id");		
		if(!eleId || !videoId) { return; }

		return new YT.Player(eleId, {
			videoId: videoId,
			width: $ele.width(),
			height: $ele.height(),
			playerVars: {rel: 0},
			events: {
				onReady: function (evt) {
					var player = evt.target;
					player.playVideo();
				}
			}
		})
	},

	playInModal: function (videoId) {
		    if(!videoId) { return; }

		modal.setContent('<div class="responsive-embed"><div id="video-player"></div></div>');

		new YT.Player("video-player", {
			videoId: videoId,
			events: {
				onReady: function (evt) {
					var player = evt.target;
					modal.events.onOpen(function () {
						var modalBodyWidth = $(".modal-body").width();
						//$("#video-player").width(modalBodyWidth);
						player.playVideo();
					});
					modal.events.onClose(function () { player.destroy(); });
					modal.open();
				}
			}
		})
	},

	playerThumbnail: function ($ele, videoId) {
		var eleId = $ele.attr("id");
		if(!eleId || !videoId) { return; }

		return new YT.Player(eleId, {
			videoId: videoId,
			width: $ele.width(),
			height: $ele.height(),
			playerVars: {rel: 0},
			autoplay: 0
		})
	},
};